import * as React from 'react';

import { P1, P2 } from 'components/typography';

type Props = {
  rows: Array<Array<React.ReactNode>>;
  th?: boolean;
};

const Table: React.FC<Props> = ({ rows, th }) => {
  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            {rows[0].map((cell, index) => (
              <th key={`head${index}`}>{th ? cell : <P1 as="p">{cell}</P1>}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.slice(1).map((row, index) => {
            return (
              <tr key={`row${index}`}>
                {row.map((cell, indexCell) => (
                  <td key={`cell${indexCell}`}>{cell && <P2 html={cell as string} />}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
